import { useEffect, useState } from "react";

import { dark, knoword } from "~/theme";

export const useTheme = () => {
  const [isDark, setIsDark] = useState(
    () =>
      typeof document !== "undefined" &&
      document.documentElement.getAttribute("data-theme") === "dark",
  );

  useEffect(() => {
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === "attributes") {
          setIsDark(
            document.documentElement.getAttribute("data-theme") === "dark",
          );
        }
      }
    });

    observer.observe(document.documentElement, {
      attributeFilter: ["data-theme"],
    });
  }, []);

  return isDark ? dark : knoword;
};
